import { FieldErrors, ResolverOptions } from 'react-hook-form';
import { FormValues } from '@/constants/formTypes';
import { FormServerError } from '@/schemas/formConfigResolver';

export function createErrorsFromServer(serverErrors: FormServerError[], fields: ResolverOptions<FormValues>['fields']) {
  return serverErrors.reduce<FieldErrors<FormValues>>((errors, { key, message }) => {
    const ref = fields[key]?.ref;

    if (ref) {
      errors[key] = {
        type: 'server',
        message: message,
        ref: ref,
      };
    } else {
      console.error(`Field ${key} not found in form`);
    }

    return errors;
  }, {});
}
